import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { findIndex } from 'lodash';
import { DataService } from 'app/services';
export type ToastType = 'success' | 'error' | 'warning';
export interface Toast {
  type: ToastType;
  title: string;
  posted: number;
  pending: number;
  failed: number;
  body: string;
  delay: number;
}
@Injectable({
  providedIn: 'root',
})
export class QboToastService {
  subject: BehaviorSubject<any>;
  toast$: Observable<Toast>;
  toasters: any[] = [];

  constructor(private dataService: DataService) {
    this.subject = new BehaviorSubject<Toast>(null);
    this.toast$ = this.subject.asObservable().pipe(filter((toast) => toast !== null));
  }
  updateToaster({ isStart, isComplete, uniqueId, statementName, totalCount, failedCount, successCount, pendingCount,isBulkStatementSent }) {
    const index = findIndex(this.toasters, { uniqueId });
    if (index < 0) {
      this.toasters = [{ uniqueId, statementName, totalCount, failedCount, successCount, pendingCount , isBulkStatementSent, isComplete , isStart, }, ...this.toasters];
    } else {
      this.toasters[index] = { uniqueId, statementName, totalCount, failedCount, successCount, pendingCount , isBulkStatementSent, isStart, isComplete };
    }
    this.subject.next(this.toasters);
    if (isComplete) {
      this.toasters = this.toasters.filter((msg) => msg.uniqueId !== uniqueId);
    }
    this.subject.next(this.toasters);
  }
}
  